import SelectClubWrap from './SelectClubWrap';
export default SelectClubWrap;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/SelectClub/index.ts